import React from "react";
import { Button, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

type FormButtonsProps = {
  onSave: (args) => void;
  onCancel: (args) => void;
  type?: "button" | "submit" | "reset";
  saveText?: string;
  cancelText?: string;
  disabled?: boolean;
};

export const FormButtons = (props: FormButtonsProps) => {
  const {t} = useTranslation("addServiceRequestSubject")
  const {
    onSave,
    onCancel,
    type = "submit",
    saveText = t("save"),
    cancelText = t("cancel"),
    disabled = false,
  } = props;
  const theme = useTheme();
  return (
    <div className="flex-shrink-0 border-t border-gray-200 p-4 sm:px-6">
      <div className="flex justify-end space-x-3 cursor-pointer">
        <Button
          sx={{ width: "100px" }}
          variant={"outlined"}
          onClick={onCancel}
          color={"error"}
        >
          {/* {t("cancel")} */}
          {cancelText}
        </Button>
        <Button
          sx={{
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
            "&:hover": {
              backgroundColor: theme.palette.grey[400],
            },
            minWidth: "100px",
            width: "full",
          }}
          variant={"contained"}
          onClick={onSave}
          type={type}
          disabled={disabled}
        >
          {saveText}
          {/* {t("save")} */}
        </Button>
      </div>
    </div>
  );
};
